'use strict';

var jsforce = require('../core');
jsforce.browser = require('./client');
module.exports = jsforce;
